module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsTablet-cd2dbf7789e20d5b58168245de55800e.png";